/**
 * HTML content for special sections that are purely HTML/CSS based.
 */


/**
 * HTML content for the Preface section.
 */
export const PREFACE_HTML = `
<div class="preface-section">
  <h2>Welcome to the Class Profile</h2>
  <p>
    This class profile is a collection of data and insights gathered from our graduating class.
    It provides an overview of our demographics, experiences, and perspectives as we complete our journey.
  </p>
</div>
`;

/**
 * Intro HTML for the Correlations section.
 */
export const CORRELATIONS_INTRO_HTML = `
<h2>Correlation Preface</h2>
<p>
  <b>Correlation does not equal causation.</b> Correlation is not intended to find causes and effects. 
  This section only analyzes the results and experiences our class as submitted and finds trends between 
  our different demographics. If A and B are correlated, it does not mean A causes B or 
  B causes A. It simply shows that A and B were typically observed together (for positive correlation)
</p>
<p>
  Some stats have been omitted because they were either irrelevant, low sample size, or can be used 
  to identify certain individuals due to their specificity. We had seperated our survey into two
  sections to prevent our team from easily finding out whose responses were submitted by which person.
  This means that some correlations like gender (sheet A) could not be correlated with wages (sheet B)
  without significant effort to re-identify individuals, which undermines why we split it into 2 sheets.
</p>
<p>
  Correlation values closer to 1 mean that higher values of A were observed to have higher values 
  of B. Values closer to 0 mean that higher values of A did not generally follow with a higher or lower 
  value of B (low/no correlation). Values closer to -1 mean that higher values of A were observed to 
  have lower values of B. Typially correlations between -0.3 to 0.3 are considered weakly correlated 
  and no conclusion can be reasonably made. However, I used 0.2 as a threshold just for fun and out of interest 
  and that I kinda suck at normalizing data.
</p>
<p>
  Note that this section is typically not seen on other class profiles. In the case that anyone else may
  want to use this analysis, I used a lot of one-hot encoding and spearman correlation to better capture
  trends between categorical and ordinal data. I did not study statistics. I am sure there are better methods
  to do this analysis, but this is just a fun little section I wanted to do.
</p>`;

/**
 * HTML content for the Acknowledgements section.
 */
export const ACKNOWLEDGEMENTS_HTML = `
<div class="acknowledgements-section">
  <h2>Acknowledgements</h2>
  <p>
    Thanks to @Sumnit-Boparai, @brewedcoffee, @KristinChengWu, and @Winston-Lu who helped collect, process, and present the survey responses.
  </p>
  
  <p>
    Thanks to our professors, TAs, lab instructors, and support staff for supporting our degrees!
  </p>
  
  <p>
    Most importantly, thank you to all our classmates who took the time to fill out the survey 
    and share their experiences. This tradition wouldn't exist without your participation.
  </p>
</div>

<style>
  .acknowledgements-section {
    max-width: 800px;
    margin: 0 auto;
    padding: 2rem;
  }
  
  .acknowledgements-section h2 {
    text-align: center;
    margin-bottom: 2rem;
  }
  
  .acknowledgements-section h3 {
    margin-top: 1.5rem;
    margin-bottom: 0.5rem;
    color: var(--theme-color, #4f46e5);
  }
  
  .acknowledgements-section p {
    line-height: 1.6;
    margin-bottom: 1rem;
  }
</style>`;
